import { render, staticRenderFns } from "./table-tree.vue?vue&type=template&id=0c50ca42&"
import script from "./table-tree.vue?vue&type=script&lang=js&"
export * from "./table-tree.vue?vue&type=script&lang=js&"
import style0 from "./table-tree.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports